export default "__VITE_ASSET__CeBzU0tw__"